import React, { useState } from "react";
import { useContext } from "../../../context";
import { ConfirmModal } from "../../../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { useMarkNoShow } from "../../../hooks/useMarkNoShow";

function ModalConfirmNoShow() {
  const {
    modals: {
      confirmNoShow: { state, isOpen, close },
    },
  } = useContext();

  const markNoShow = useMarkNoShow();

  return (
    <>
      {isOpen && (
        <ConfirmModal
          isOpen
          isConfirming={markNoShow.isLoading}
          onClose={close}
          onCancel={close}
          confirmTitle={state.isAdditionalProvider ? "Yes, mark" : undefined}
          cancelTitle="No, go back"
          onConfirm={() =>
            markNoShow.initiate({
              charge: state.charge,
              isAdditionalProvider: state.isAdditionalProvider,
            })
          }
        >
          {state.isAdditionalProvider
            ? "Are you sure you want to mark as no show this provider from the appointment?"
            : "Are you sure you want to mark as no show this appointment?"}
        </ConfirmModal>
      )}
    </>
  );
}

ModalConfirmNoShow.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: ({ charge, isAdditionalProvider }) => {
      setState({ charge, isAdditionalProvider });
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalConfirmNoShow };
